module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/advantage_1.png";